// client/src/pages/ContactPage.js

import React from "react";
import ContactForm from "../components/ContactForm";

function ContactPage() {
  return (
    <div className="py-16">
      <ContactForm />
    </div>
  );
}

export default ContactPage;
